import React from 'react'
import AnalysisContainer from 'components/wrapper/AnalysisContainer'
import { getRequiredAnalysis, postRequiredAnalysis } from 'api/urls'
import { useHistory } from 'react-router'
import { getQueryParams } from 'utils/Utils'

const bvps_analysis = {

    estimated_cagr_in_bvps: {
        lable: <span>BVPS CAGR %</span>,
        placeholder: 'Ex: 100',
        col: 6,
    },
    estimated_pb_last_year: {
        lable: <span>Exit P/B</span>,
        placeholder: 'Ex: 12',
        col: 6,
    },
    discount_rate: {
        lable: <span>Discount %</span>,
        placeholder: 'Ex: 12',
        col: 6,
    },
    margin_of_safety: {
        lable: <span>Margin of safety %</span>,
        placeholder: 'Ex: 90',
        col: 6,
    },
    ttm_bvps: {
        style: { border: 'none', background: 'none', fontWeight: '600', cursor: 'auto', color: 'black', textTransform: 'capitalize' },
        lable: <span>TTM BVPS</span>,
        placeholder: '0',
        readOnly: true,
        col: 6,
    },
    current_pb: {
        style: { border: 'none', background: 'none', fontWeight: '600', cursor: 'auto', color: 'black', textTransform: 'capitalize' },
        lable: <span>Current PB</span>,
        placeholder: '0',
        readOnly: true,
        col: 6,
    },
    estimated_bvps_last_year: {
        style: { border: 'none', background: 'none', fontWeight: '600', cursor: 'auto', color: 'black', textTransform: 'capitalize' },
        lable: <span>Estimated BVPS after<br />10 yrs (Rs.)</span>,
        placeholder: '0',
        ignore: true,
        readOnly: true,
        col: 6,
    },
    estimated_stock_price_last_year: {
        style: { border: 'none', background: 'none', fontWeight: '600', cursor: 'auto', color: 'black', textTransform: 'capitalize' },
        lable: <span>Estimated Stock Price<br />after 10 yrs (Rs.)</span>,
        placeholder: '0',
        ignore: true,
        readOnly: true,
        col: 6,
    },
    Present_value_of_stock: {
        style: { border: 'none', background: 'none', fontWeight: '600', cursor: 'auto', color: 'black', textTransform: 'capitalize' },
        lable: <span>Present stock value (Rs.)</span>,
        placeholder: '0',
        ignore: true,
        readOnly: true,
        col: 6,
    },
    fair_value: {
        style: { border: 'none', background: 'none', fontWeight: '600', cursor: 'auto', color: 'black', textTransform: 'capitalize'},
        lable: <span>Fair value (Rs.)</span>,
        placeholder: '0',
        ignore: true,
        readOnly: true,
        col: 6,
    }
}

const BVPSAnalysis = (props) => {
    const history = useHistory()
    const querryParams = getQueryParams(history.location.search)
    return (
        <div  {...props}>
            <AnalysisContainer
                postUrl={postRequiredAnalysis('/bvps_analysis/')}
                url={getRequiredAnalysis('bvps', querryParams.company__symbol)}
                title='Book Value (BVPS)'
                cardTextStart='Projects book value 10 years out, applies an exit P/B, discounts back.'
                cardTextEnd=''
                analysis={bvps_analysis}
                inputType='number'
            />
        </div>
    )
}

export default (BVPSAnalysis)